// eslint-disable-next-line import/prefer-default-export
export const ATS_EN = {
  // Common
  Close: 'Close',
  Save: 'Save',

  // header
  AddColumn: 'Add column',
  Notifications: 'Notifications',
  tooltipNotifications: 'Notify to candidates when their process has started',
  tooltipSearch: 'Search candidate',

  // Export Excel
  numberEmpty: 'No phone number',
  Average: 'Average',
  emailEmpty: 'No email',
  AverageEmpty: 'It does not have a questionnaire',
  cvEmpty: 'Without cv',
  Unrated: 'Unrated',
  FirstName: 'First Name',
  LastName: 'Last Name',
  Email: 'Email',
  EmailSecondary: 'Email Secondary',
  Date: 'Date',
  Qualification: 'Qualification',
  PhoneNumber: 'Phone number',
  SecondaryNumber: 'Secondary Number',
  Description: 'Description',
  DescriptionEmpty: 'Without description',
  cvWithBias: 'Cv with bias',
  cvWithoutBias: 'Cv without bias',
  Comments: 'Comments',
  CommentsEmpty: 'No comment',

  // Modal search candidates
  allcolumns: 'All columns',
  searchCandidates: 'Search candidate by name',
  cancelSearch: 'Cancel',

  // modalImport
  ImportHeader: 'Import candidates',
  ImportExcell: 'Import from Excell',
  CandidateFirstName: 'First name:',
  CandidateLastName: 'Last name:',
  CandidateEmail: 'Email:',
  CandidatePhone: 'Phone:',
  Cv: 'CV:',
  Accept: 'Accept',

  // modalOwners
  Owners: 'Owners',
  OwnersHeader: 'Add owners',
  Recruiter: 'Recruiter',
  User: 'User',
  AddOwnersMessage: 'Vacancy owners will be updated.',

  // modalCriteria
  CriteriaHeader: 'Criteria',
  CriteriaName: 'Criteria name',
  CriteriaMessage1: 'Add criteria that will be evaluated',
  CriteriaMessage2: 'will be applied in the whole vacancy',
  AddCriteriaConfirmation: 'Once added this criterion you will not be able to modify it, do you want to continue?',
  CriteriaDeleteConfirmation:
    'Are you sure you want to delete this criterion? Once is deleted, the average scores will be recalculated.',
  ChangeTemplateConfirmation: 'If you change the template scores from the previous one will be lost',
  AddTemplate: 'Add template',
  CriterionName: 'Criterion',
  AddCriterion: 'Add criterion',
  tooltipAddCriterion: 'Add criterion to the vacancy',
  WeightInvalidValue: 'Weight value must be between 0.1 and 10',

  // modalDrag
  modalDragHeader: 'Where to move the applicant?',
  MessageMagic1: 'Define the treshold score to move a candidate from ',
  MessageMagic2: ' to the selected column.',
  WantToAddEmail: 'Do you want to add an email?',
  SelectColumn: 'Select column',
  MoveThemAll: 'Move them all',
  MessageEmptyQuestions: 'In order to use the',
  MessageSecondEmptyQuestions: 'you need to assign a question block to the vacancy',
  MessageButtonEmpty: 'Assign questions',
  No: 'No',
  Yes: 'Yes',
  Cancel: 'Cancel',
  Add: 'Save',
  Saved: 'Saved',
  AddEmailMessage: 'Here you can edit the email that will be sent to the candidates in the column: ',
  CandidateName: 'Candidate name: ',
  CompanyName: 'Company name: ',
  VacancyName: 'Vacancy name: ',
  RedactEmail: 'Redact your email',
  Subject: 'Subject',
  CorrectAnswers: 'Correct Answers',
  WrongAnswers: 'Incorrect Answers',
  RangeAnswers: 'Range Answers',
  ClosedAnswers: 'Closed Answers',
  MultipleChoice: 'Multiple Choice',
  SelectType: 'Select Question',
  InitialValue: 'Initial Value',
  FinishValue: 'End Value',
  TrueAnswers: 'Answer: YES',
  FalseAnswers: 'Answer: NO',
  SelectQuestions: 'Selected Questions',
  SelectCondition: 'Select condition',
  ColumnCandidate: 'New Candidates',
  EqualTo: 'Equal to',
  TextTab: 'Rule',
  LessOrEqual: 'Less than or equal to',
  GreaterOrEqual: 'Greater than or equal to',
  Notify: 'Notify Candidates',
  DeleteRule: 'Delete Rule',
  AddRule: 'Add Rule',
  MessagePlaceholder:
    'Dear {CANDIDATE} this is an automatic email to inform you that you are still active in the selection process',
  MessageErrorColumns: 'You must select the destination column',
  MessageErrorPercentageEmpty: "The percentage can't be left empty",
  MessageErrorPercentageZero: 'The percentage must be greater than 0',
  MessageErrorCondition: 'You must select a condition',
  MessageErrorValueRange: 'The value must be between 1 and 10',
  MessageErrorClosedAnswers: 'You must select a question',
  MessageErrorRangeInitialValue: 'You must assign an initial value',
  MessageErrorRangeFinishValue: 'You must assign an end value',
  MessageErrorSubject: 'The matter cant be left empty',
  MessageErrorMessage: "The message can't be left empty",
  MessageConnector: 'on the rule',
  MessageConnectorTabs: 'on the text',
  MessageSuccessMagicCreate: 'Magic Action created',
  // popupColumn
  Manage: 'Manage',
  EditName: 'Edit name',
  Delete: 'Delete',
  AddCandidate: 'Add candidate',
  Multiselect: 'Multiselect',
  CloseMultiselect: 'Close multiselect',
  // popper
  ExportCandidates: 'Export candidates',
  ImportCandidates: 'Import candidates',
  ScoreCriteria: 'Score criteria',
  AddOwners: 'Add owners',
  MagicActions: 'Magic Actions',
  EditVacancy: 'Edit Vacancy',
  Analitics: 'Analitics vacancy',

  // modalCustomEmail
  CustomEmailHeader: 'Custom email',

  // manageColumnsOwners
  ManageColumnOwnersHeader: 'Manage column owners',
  ManageColumnOwnersQuestion: 'Who are the column owners of this vacancy?',
  SelectAll: 'Select all',
  NameOwners: 'Name owners',
  DeleteFromOwners: 'Delete from owners',
  WhoToNotify: 'Who to notify via Slack?',
  placeholderChooseUsers: 'Choose users or channels',
  DidYouKnow:
    'Did you know...? You can notify your colleagues via Slack, you only have to link your Slack account and try again!',
  Integrate: 'Integrate',

  // modalAddCandidate
  NewCandidate: 'New candidate',
  placeholderFirstName: 'First name',
  placeholderLastName: 'Last name',
  placeholderEmail: 'Email',
  placeholderPhone: 'Phone',
  SelectCv: 'Select cv (Optional)',
  GeneratedId1: 'We have generated the ID: ',
  GeneratedId2: ' for your file',
  placeholderTextArea: 'Type something about the candidate',
  AddPhoneSecondary: 'Secondary number',
  AddEmailSecondary: 'Secondary email',

  // modal Reject Candidate
  RejectApplicantHeader: 'How should we notify the candidate?',
  RejectApplicantMessage1: 'You are rejecting candidate ',
  AcceptApplicantMessage1: 'You are accepting candidate ',
  RejectApplicantMessage2: ' from this vacancy ',
  Customize: 'Customize',
  DoNotNotify: "Don't notify",
  Template: 'Template',

  // droppable
  NewName: 'New name',
  Unnamed: 'Unnamed',
  PersonalFilter1: 'Personal filter 1',
  PersonalFilter2: 'Personal filter 2',
  RejectedWillBeNotified: 'Applicant will be notified by email',
  NewCandidates: 'New applicants',
  Accepted: 'Accepted',
  Rejected: 'Rejected',
  // Multiselect
  Column: 'Column',
  Done: 'Done',

  // magic actions
  NoMagicYet: 'There are no Magic Actions yet',
  tooltipEditMagic: 'Edit Magic Action',
  tooltipDeleteMagic: 'Delete Magic Action',
  Move: 'Move to another column',
  DeleteConfirmation: 'Are you sure you want to delete this Magic action?',
  CannotBeDone: 'This action cannot be done',
  ImSure: "I'm sure",
  moveRule: 'Move ruler',

  // Modal Rechazar Candidatos
  RejectCandidatesHeader: 'Reject candidates',
  AreYouSureToReject: 'Are you sure you want to reject these candidates?',
  YouWantToNotifyThem: 'Do you want us to notify them?',

  // NotificationManager
  YouHaveToSelect: 'You have to select a column and at least an applicant',
  ComingSoon: 'Soon, you will be able to add your own candidates in the AtsJsx',
  InvalidName: 'Invalid name',
  CannotManipulate: 'This column cannot be manipulated',
  BambooSuccess: "Applicant's info successfully transferred to BambooHR",
  BambooError: 'It was not possible to transfer the applicant to BambooHR',

  // Test
  addTest: 'Add test',
  statusTest: 'Status',
  nameTest: 'Name',
  dateTest: 'Date',
  actionsTests: 'Actions',
  emptyTest: 'There is no data available',
  selecTemplate: 'Do you want use a template or you prefer create a new test?',
  createNewTest: 'Create new',
  cancelTest: 'Cancel',
  sendTest: 'Send',
  searchTemplate: 'Search template',
  selectedTest: 'Select',
  sendTestTitle: 'Send test to candidate with time limit',
  nameCompleteTest: 'Test name',
  typeTest: 'Test',
  instructionsTests: 'Instructions',
  timeTest: 'Time of test',
  stopWatchTest: 'Time stopwatch',
  visibleTest: 'Visible',
  noVisibleTest: 'No visible',
  responseFormat: 'Answer formatting',
  urlTest: 'URL',
  fileTest: 'File',
  writeTest: 'Write',
  addFile: 'Add file',
  selectFile: 'Choose files',
  placeholderWriteTest: 'Write your test below',
  sendNewTest: 'Send test',
  filesAdjuntos: 'Files selected',
  othersFiles: 'Others files',
  deleteFileTest: 'delete file',
  backTest: 'Back',
  daysTest: 'Days',
  hoursTest: 'Hours',
  minutesTest: 'Minutes',
  introduccionTest: 'Introduction',
  instructionsprevTest: '(Pre-test instrctions)',

  // MODAL SEND EMAIL
  ChooseEmailProvider: 'Choose with which email provider',

  // MODAL REJECT CANDIDATE
  HowNotifyCandidate: 'How should we notify you?',
};
